import axios from "axios";
import swal from "sweetalert";

let sessionEndedShown = false; // several requests can fail together: one notice, one redirect

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
  headers: {
    Authorization: "JWT " + localStorage.getItem("accessToken"),
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    // Handle timeout and network errors (no response object)
    if (!error.response) {
      console.error("Network error or timeout:", error.message);
      return Promise.reject(error);
    }

    if (error.response.status === 500) {
      // window.location = "/error";
    }
    // 401 on a request that carried a session token = the session has ended (token expired, or revoked by an admin or by a
    // password change). Clear the session keys and send the user to the login page once, instead of leaving pages
    // to show a generic error. Not keyed on statusText: it is empty over HTTP/2. A 401 without a token
    // (a wrong password on the login form) is left to the caller.
    if (error.response.status === 401) {
      // Judged by the request itself, not by storage: requests sent together all carry the token, but the
      // first refusal clears storage before the others come back.
      const sentAuth = String(error.config?.headers?.Authorization ?? "");
      const hadSession = sessionEndedShown || (sentAuth.startsWith("JWT ") && sentAuth !== "JWT null");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      localStorage.removeItem("has_admin_access");
      axiosInstance.defaults.headers["Authorization"] = null;
      if (hadSession) {
        if (!sessionEndedShown) {
          sessionEndedShown = true;
          swal("Signed out", "Your session has ended. Please log in again.", "info", { buttons: false, timer: 2500 });
          setTimeout(() => (window.location.href = "/login"), 2500); // not tied to the modal: a page could replace it
        }
        // The page is being left: keep its request pending so its own error modal (e.g. Profile's, Download
        // History's "Failed") does not replace the notice.
        return new Promise(() => {});
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
